/* eslint-disable react-hooks/exhaustive-deps */
import React, { FC, useEffect } from 'react';
import { GalleryImage } from './ImagesCarousel';
import { IconArrowRight, IconArrowBack } from '../../images';
import { ReactComponent as XWindowIcon } from '../../images/x-window.svg';
import { ReactComponent as InfoIcon } from '../../images/details.svg';
import { Box } from '@mui/material';
import LocationTag from '../LocationTag/LocationTag';
import { SmartImage } from '@cellebrite/saas-ui-common';

interface CarouselFullScreenModeProps {
    onClose: () => void;
    currentImagePosition: number;
    items: GalleryImage[];
    onNextItem: () => void;
    onPreviousItem: () => void;
}

const CarouselFullScreenMode: FC<CarouselFullScreenModeProps> = (props) => {
    const onKeyPress = (e: KeyboardEvent) => {
        if (e.key === 'Escape') {
            document.body.classList.remove('hide-scroller');
            props.onClose();
        }
        if (e.key === 'ArrowRight') {
            props.onNextItem();
        }
        if (e.key === 'ArrowLeft') {
            props.onPreviousItem();
        }
    };

    useEffect(() => {
        document.body.classList.add('hide-scroller');
        window.addEventListener('keyup', onKeyPress);

        return () => {
            window.removeEventListener('keyup', onKeyPress);
        };
    }, []);

    return (
        <Box className="modal">
            <Box
                onClick={(e) => {
                    e.stopPropagation();
                    document.body.classList.remove('hide-scroller');
                    props.onClose();
                }}
                className="modal-close-btn carousel-btn-base"
            >
                <XWindowIcon className="fill-l" />
            </Box>
            {props.items.length > 1 && (
                <Box onClick={props.onNextItem} className="modal-next-btn carousel-btn-base">
                    <IconArrowRight className="fill-l" />
                </Box>
            )}
            {props.items.length > 1 && (
                <Box onClick={props.onPreviousItem} className="modal-previous-btn carousel-btn-base">
                    <IconArrowBack className="fill-l" />
                </Box>
            )}

            {props.items.map((item, index) => {
                return (
                    <Box
                        key={index}
                        sx={{
                            display: index === props.currentImagePosition ? 'flex' : 'none',
                            userSelect: 'none',
                            width: 'calc(100% - 110px)',
                            height: '100%',
                            alignItems: 'center',
                        }}
                    >
                        <SmartImage
                            src={item.src}
                            skeletonStyles={{ backgroundColor: 'gray' }}
                            contain={true}
                            labelElement={
                                item.label && (
                                    <LocationTag icon={<InfoIcon style={{ fill: 'white' }} />} address={item.label} />
                                )
                            }
                        />
                    </Box>
                );
            })}
        </Box>
    );
};

export default CarouselFullScreenMode;
